"use client";

import React, { useEffect, useState } from "react";
import styles from "./GSTBenefit.module.scss";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { fetchDynamicConfig } from "@services/booking-serivce";
import { useIsMobile } from "@hooks/use-mobile";

interface GSTBenefitCardProps {
  cityName: string;
}

const GSTBenefitCard: React.FC<GSTBenefitCardProps> = ({ cityName }) => {
  const [gstConfig, setGstConfig] = useState<any>(null);
  const isMobile = useIsMobile();
  useEffect(() => {
    const fetchGSTConfig = async () => {
      try {
        const config = await fetchDynamicConfig({
          key: "new_car_gst_sellable",
          group: "Acko_Drive",
        });
        setGstConfig(config?.data);
      } catch (error) {
        console.error("Error fetching GST config:", error);
        setGstConfig(null);
      }
    };

    fetchGSTConfig();
  }, []);

  if (
    !gstConfig?.new_car_gst_sellable?.sellable_cities?.includes(
      cityName.toLowerCase()
    )
  )
    return null;

  return (
    <div className={styles.gstBenefitCard}>
      <div className={styles.gstIcon}>
        {isMobile ? (
          <Image
            src={`${assetLoader()}/icons/gst-savings.svg`}
            alt="GST Savings"
            width={52}
            height={40}
          />
        ) : (
          <Image
            src={`${assetLoader()}/icons/gst-savings-destop.svg`}
            alt="GST Savings"
            width={87}
            height={34}
          />
        )}
      </div>
      <div className={styles.gstText}>
        Good news! The price you see already includes GST savings.
      </div>
    </div>
  );
};

export default GSTBenefitCard;
